import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Country, LocationState, State } from '../../components/interfaces';
import { fetchCountries, fetchProvinces } from '../../services';

const initialState: LocationState = {
    selectedCountry: null,
    selectedProvince: null,
    countries: [],
    provinces: [],
    loading: false,
    error: undefined,
};

const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        resetLocation(state) {
            state.selectedCountry = null;
            state.selectedProvince = null;
            state.countries = [];
            state.provinces = [];
        },
        setSelectedCountry(state, action: PayloadAction<string | null>) {
            state.selectedCountry = action.payload;
        },
        setSelectedProvince(state, action: PayloadAction<string | null>) {
            state.selectedProvince = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCountries.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchCountries.fulfilled, (state, action: PayloadAction<Country[]>) => {
                state.countries = action.payload;
                state.loading = false;
            })
            .addCase(fetchCountries.rejected, (state, action) => {
                state.loading = false;
                state.error = 'Failed to fetch countries';
            })
            .addCase(fetchProvinces.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchProvinces.fulfilled, (state, action: PayloadAction<State[]>) => {
                state.provinces = action.payload;
                state.loading = false;
            })
            .addCase(fetchProvinces.rejected, (state, action) => {
                state.loading = false;
                state.error = 'Failed to fetch provinces';
            });
    },
});

export const { resetLocation, setSelectedCountry, setSelectedProvince } = locationSlice.actions;

export default locationSlice.reducer;
